import { render } from "./attack.vue?vue&type=template&id=4a787bfb"
import script from "./attack.vue?vue&type=script&lang=js"
export * from "./attack.vue?vue&type=script&lang=js"

import "./attack.vue?vue&type=style&index=0&id=4a787bfb&lang=scss"

import exportComponent from "D:\\repos\\rivendom-compendium\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__